// extracted by mini-css-extract-plugin
module.exports = {"red_color":"dece2e673c--red_color--3uPvr"};